import React from "react";
import MyCalendar from "./MyCalendar";

// Helper to detect mobile
const isMobile = window.innerWidth <= 768;

const popupStyle = {
  position: "fixed",
  top: "45%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: 3050000000,
  background: "black",
  padding: "25px",
  borderRadius: "16px",
  width: isMobile ? "95%" : "80%",     // ✅ mobile = 90%
  maxWidth: isMobile ? "95%" : "80%",  // ✅ mobile = 90%
  minWidth: isMobile ? "95%" : "70%",
  height: "auto",
  maxHeight: "90vh",
  overflowY: "auto",
  color: "white",
  boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
};

const closeButtonStyle = {
  position: "absolute",
  top: "20px",
  right: "15px",
  border: "none",
  background: "transparent",
  fontSize: "32px",
  cursor: "pointer",
  color: "white",
};

function CalendarPopup({ onClose, onClick }) {
  return (
    <div style={popupStyle}>
      <button onClick={onClose} style={closeButtonStyle}>
        ✖
      </button>

      <div
        style={{
          marginTop: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <MyCalendar onClick={onClick} />
      </div>
    </div>
  );
}

export default CalendarPopup;
